import $ from 'jquery';

$(function () {
    $(document).on('click', 'a[href*="#"]:not([data-toggle]):not([data-slide]):not(.inline):not([data-controls])', function (e) {
        if ($(this).attr('href').substring(0, 1) !== '#') {
            // Extract the current page's URL without the hash
            const currentPage = window.location.href.split('#')[0];
            // Create a full URL from the link's href
            const fullLinkUrl = new URL($(this).attr('href'), window.location.origin);

            if (!fullLinkUrl.href.startsWith(currentPage)) {
                return;
            }
        }

        const targetId = $(this).attr('href').split('#')[1];
        const $targetElement = $(`#${targetId}`);
    
        // Check if the target element exists
        if ($targetElement.length) {
            e.preventDefault(); // Prevent the default anchor behavior
            $(this).trigger('blur');
    
            // Calculate the scroll position, adjusting for a fixed navbar if present
            const offset = $('.navbar.sticky-top').outerHeight() || 0;
            const scrollToPosition = $targetElement.offset().top - offset;

            const startPosition = window.scrollY;
            const distance = scrollToPosition - startPosition;
            const duration = 1000;
            let startTime = null;

            function animation(currentTime) {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const easing = easeOutQuint(timeElapsed, startPosition, distance, duration);
                window.scrollTo(0, easing);

                if (timeElapsed < duration) requestAnimationFrame(animation);
            }

            function easeOutQuint(t, b, c, d) {
                t /= d;
                t--;
                return c * (t * t * t * t * t + 1) + b;
            }

            requestAnimationFrame(animation);
        }
    });
});